import * as R from 'ramda';
import { css, SerializedStyles } from '@emotion/core';
import { onMobileDevice } from '../globalStyle/mediaQueries';


/**
 * This function makes a style you can apply to a container to give it mobile-friendly margins both in row and column
 * configurations.
 */
export const makeAdaptiveSpacing = (horizMarginPx: number, vertMarginPx?: number) => css`
  & > * {
    margin-right: ${horizMarginPx}px;
  }
  & > *:last-child {
    margin-right: 0;
  }

  ${onMobileDevice} {
    & > * {
      margin-right: 0;
      margin-bottom: ${vertMarginPx ?? horizMarginPx}px;
    }
    & > *:last-child {
      margin-right: 0;
      margin-bottom: 0;
    }
  }
`;

/**
 * Default layout margins
 */
export const ADAPTIVE_SPACING = makeAdaptiveSpacing(25);


/**
 * Makes a style that truncates text at the given number of lines in webkit browsers
 */
export const ellipsizeAt = R.memoizeWith(
  (lines: number): string => `${lines}`,
  (lines: number): SerializedStyles => css`
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: ${lines}; 
    -webkit-box-orient: vertical;
    word-break: break-word;
    hyphens: auto;
    overflow-wrap: break-word;
  `,
);
